import { render, staticRenderFns } from "./OrigenRecursos.vue?vue&type=template&id=093a838d&scoped=true"
import script from "./OrigenRecursos.vue?vue&type=script&lang=js"
export * from "./OrigenRecursos.vue?vue&type=script&lang=js"
import style0 from "./OrigenRecursos.vue?vue&type=style&index=0&id=093a838d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093a838d",
  null
  
)

export default component.exports